/**
 * Le 5 à 7 Podcast — Cadeau gratuit + Upsell dans le side cart (v1)
 * Adapté du système okbye.ca pour le thème Shopify HORIZON.
 *
 * Fonctionnalités :
 *  1. Barre de livraison gratuite (style Rhode) en haut du tiroir
 *  2. Widget « Choisis ton cadeau gratuit » au-dessus du footer
 *  3. Panneau « plus de détails » sur le cadeau
 *  4. Carrousel d'upsell (ton merch) une fois le cadeau ajouté
 *  5. Quantité des cadeaux verrouillée à 1, retirés si panier vide
 *
 * INSTALLATION :
 *  1. Admin Shopify → Boutique en ligne → Thèmes → Modifier le code
 *  2. Dossier « assets » → Ajouter un nouvel asset → crée « 5a7-free-gift-cart.js »
 *     et colle tout ce fichier dedans
 *  3. Dossier « layout » → theme.liquid → juste avant </body>, ajoute :
 *     {{ '5a7-free-gift-cart.js' | asset_url | script_tag }}
 */

(function () {

  console.log("%c[5a7] side cart cadeau v8 chargé", "color:#fff;background:#FF5A4E;padding:2px 6px;border-radius:4px");

  // ─── CONFIG — MODIFIER ICI ────────────────────────────────────────────────

  // ⚠️ À REMPLIR : crée d'abord tes 2 produits-cadeaux à 0 $ dans Shopify
  // (« Sent-bon Jess » et « Sent-bon Rose »), puis colle leur variantId
  // et leur handle ici (voir instructions).
  var GIFTS = [
    {
      variantId: 48904095465689,             // « le sent bon JESS »
      handle: "les-sent-bon-copie",
      displayLabel: "Sent-bon Jess",
    },
    {
      variantId: 48904114995417,             // « le sent bon ROSE »
      handle: "le-sent-bon-jess-copie",
      displayLabel: "Sent-bon Rose",
    },
  ];

  // Upsells : ton merch à suggérer une fois le cadeau ajouté (optionnel).
  var UPSELLS = [
    // { variantId: 0, handle: "handle-du-produit", displayLabel: "Nom du produit" },
  ];

  // Seuil de livraison gratuite, en CENTIMES (12500 = 125 $).
  // Mis à 0 = barre désactivée (aucune barre de livraison affichée).
  var FREE_SHIPPING_THRESHOLD = 0;

  // Texte du panneau « plus de détails »
  var DETAILS_TEXT = "Reçois un sent-bon gratuit avec chaque commande, pendant les stocks disponibles. Choisis entre le sent-bon Jess et le sent-bon Rose — équipe Jess ou équipe Rose? Le cadeau est ajouté automatiquement à ta commande, aucun code requis. Non échangeable, non remboursable.";

  // Textes du widget
  var WIDGET_TAG = "ON T'OFFRE UN CADEAU GRATUIT AVEC ACHAT";
  var WIDGET_SOUS_TAG = "fais ton choix";
  var UPSELL_TITLE = "Complète ta commande 5à7";

  // Couleur d'accent (boutons)
  var ACCENT = "#FF5A4E";

  // ─── STATE ────────────────────────────────────────────────────────────────

  var GIFT_VARIANT_IDS = GIFTS.map(function (g) { return g.variantId; }).filter(Boolean);
  var selectedGiftIndex = 0;
  var currentUpsellIndex = 0;
  var giftImages = {};
  var upsellImages = {};
  var upsellPrices = {};
  var currentCartVariantIds = [];
  var cartIsEmpty = false;
  var imagesLoaded = false;
  var clickListenerAttached = false;
  var detailsOpen = false;
  var giftTitles = {};   // handle → titre réel du produit (pour repérer les lignes)

  // ─── SÉLECTEURS HORIZON ───────────────────────────────────────────────────
  // v2 : recherche PROFONDE — traverse aussi les shadow roots des composants
  // web d'Horizon, avec une heuristique de secours basée sur le bouton
  // de paiement. Diagnostics dans la console ([5a7] ...).

  function tousLesElements(racine) {
    // Retourne tous les éléments, en descendant dans les shadow roots ouverts
    var resultat = [];
    var pile = [racine || document];
    while (pile.length) {
      var noeud = pile.pop();
      var els = (noeud.querySelectorAll ? noeud.querySelectorAll("*") : []);
      for (var i = 0; i < els.length; i++) {
        resultat.push(els[i]);
        if (els[i].shadowRoot) pile.push(els[i].shadowRoot);
      }
    }
    return resultat;
  }

  function chercheProfond(selecteurs) {
    // Essaie chaque sélecteur dans le document, puis dans les shadow roots
    for (var i = 0; i < selecteurs.length; i++) {
      var el = document.querySelector(selecteurs[i]);
      if (el) return el;
    }
    var tout = tousLesElements(document);
    for (var j = 0; j < selecteurs.length; j++) {
      for (var k = 0; k < tout.length; k++) {
        if (tout[k].matches && tout[k].matches(selecteurs[j])) return tout[k];
      }
    }
    return null;
  }

  var drawerLog = false;
  function findDrawer() {
    var el = chercheProfond([
      "cart-drawer-component",
      "cart-drawer",
      "#CartDrawer",
      ".cart-drawer",
      "[id*='cart-drawer' i]",
      "[class*='cart-drawer' i]",
      "[id*='CartDrawer']",
    ]);
    // Heuristique de secours : le dialog/aside qui contient le bouton checkout
    if (!el) {
      var checkout = chercheProfond(['[name="checkout"]', 'button[name="checkout"]', 'a[href*="/checkout"]']);
      if (checkout) {
        el = checkout.closest("dialog, aside, [class*='drawer' i], [class*='cart' i]");
      }
    }
    if (el && !drawerLog) { drawerLog = true; console.log("[5a7] tiroir trouvé :", el.tagName, el.className || el.id || ""); }
    return el;
  }

  function findFooter(drawer) {
    if (!drawer) return null;
    var selectors = [
      ".cart-drawer__footer",
      ".cart__summary",
      ".cart-drawer__summary",
      "[class*='cart__footer']",
      "[class*='summary' i]",
      "footer",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = drawer.querySelector(selectors[i]);
      if (el) return el;
    }
    // Dernier recours : remonte à partir du bouton de paiement
    var btn = drawer.querySelector('[name="checkout"], a[href*="/checkout"], button[form]');
    return btn ? (btn.closest("div,footer,form") || btn.parentElement) : null;
  }

  function findItemsTop(drawer) {
    if (!drawer) return null;
    var selectors = [
      "cart-items-component",
      ".cart-items",
      ".cart-drawer__items",
      "[class*='cart-items' i]",
      ".cart-drawer__content",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = drawer.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // ─── IMAGES & PRIX ────────────────────────────────────────────────────────

  async function loadImages() {
    if (imagesLoaded) return;
    var all = GIFTS.concat(UPSELLS);
    await Promise.all(all.map(async function (p) {
      if (!p.handle) return;
      try {
        var res = await fetch("/products/" + p.handle + ".js");
        var data = await res.json();
        var img = data.featured_image || (data.images && data.images[0]) || "";
        if (GIFT_VARIANT_IDS.indexOf(p.variantId) !== -1) {
          giftImages[p.handle] = img;
          if (data.title) giftTitles[p.handle] = data.title;
        } else {
          upsellImages[p.handle] = img;
          if (typeof data.price === "number") upsellPrices[p.handle] = data.price;
        }
      } catch (e) {}
    }));
    imagesLoaded = true;
  }

  // ─── CART API (identique sur tous les thèmes) ─────────────────────────────

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " $";
  }

  async function fetchCart() {
    var res = await fetch("/cart.js");
    return res.json();
  }

  async function addToCart(variantId, properties) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties || {} }),
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.description || "Erreur");
    return data;
  }

  async function removeFromCart(variantIds) {
    var cart = await fetchCart();
    var updates = {};
    cart.items.forEach(function (item) {
      if (variantIds.indexOf(item.variant_id) !== -1) updates[item.variant_id] = 0;
    });
    if (!Object.keys(updates).length) return;
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
    });
  }

  // Recharge le tiroir natif d'Horizon.
  // Le tiroir vit souvent DANS la section header : on détecte dynamiquement
  // la section Shopify qui le contient, on la re-télécharge, et on remplace
  // le contenu du tiroir par la version fraîche.
  async function refreshNativeCart() {
    var drawer = findDrawer();
    if (!drawer) return;

    // 1. Quelle section Shopify contient le tiroir?
    var candidats = [];
    var sec = drawer.closest(".shopify-section");
    if (sec && sec.id) candidats.push(sec.id.replace(/^shopify-section-/, ""));
    candidats.push("cart-drawer", "header");

    var etaitOuvert = !!drawer.querySelector("dialog[open]") || drawer.hasAttribute("open");

    for (var i = 0; i < candidats.length; i++) {
      var nom = candidats[i];
      try {
        var res = await fetch("/?sections=" + encodeURIComponent(nom));
        if (!res.ok) continue;
        var data = await res.json();
        var html = data[nom];
        if (!html) continue;

        // 2. Retrouve le tiroir équivalent dans le HTML frais
        var doc = new DOMParser().parseFromString(html, "text/html");
        var frais =
          doc.querySelector(drawer.tagName.toLowerCase()) ||
          doc.querySelector("cart-drawer-component, cart-drawer, .cart-drawer, [class*='cart-drawer' i]");
        if (!frais) continue;

        // 3. Remplace le contenu et restaure l'état ouvert
        drawer.innerHTML = frais.innerHTML;
        if (etaitOuvert) {
          var dlg = drawer.querySelector("dialog");
          if (dlg && !dlg.open) {
            try { dlg.showModal(); } catch (e1) { try { dlg.show(); } catch (e2) {} }
          }
        }
        console.log("[5a7] tiroir rafraîchi via la section « " + nom + " »");
        return;
      } catch (e) {}
    }

    // Fallback : évènements standards que certains thèmes écoutent
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    console.log("[5a7] rafraîchissement de section indisponible — évènement cart:refresh envoyé");
  }

  // ─── SYNC ─────────────────────────────────────────────────────────────────

  var isSyncing = false;
  var syncTimer = null;
  var pendingSync = false;
  function debouncedSync(delay) { clearTimeout(syncTimer); syncTimer = setTimeout(syncAndRender, delay || 400); }

  async function syncAndRender() {
    if (isSyncing) { pendingSync = true; return; }
    isSyncing = true;
    pendingSync = false;
    try {
      if (!imagesLoaded) loadImages().then(function () {
        if (document.getElementById("a7-gift-widget")) debouncedSync(50);
      });

      var cart = await fetchCart();
      currentCartVariantIds = cart.items.map(function (i) { return i.variant_id; });

      var hasGift = cart.items.some(function (i) { return GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1; });
      var hasReal = cart.items.some(function (i) { return GIFT_VARIANT_IDS.indexOf(i.variant_id) === -1; });
      var realTotal = 0;
      cart.items.forEach(function (i) {
        if (GIFT_VARIANT_IDS.indexOf(i.variant_id) === -1) realTotal += i.final_line_price;
      });

      cartIsEmpty = !hasReal;
      // Panier sans vrai produit → retire les cadeaux (anti-checkout 0 $)
      if (!hasReal && hasGift) {
        await removeFromCart(GIFT_VARIANT_IDS);
        await refreshNativeCart();
        cart = await fetchCart();
        currentCartVariantIds = cart.items.map(function (i) { return i.variant_id; });
        hasGift = false;
      }

      renderAll(cart, realTotal, hasGift);
    } catch (e) {
      console.log("[5a7]", e);
    } finally {
      isSyncing = false;
      if (pendingSync) { pendingSync = false; debouncedSync(100); }
    }
  }

  // ─── RENDU ────────────────────────────────────────────────────────────────

  // Horizon : le composant <cart-drawer> vit dans le header, mais le vrai
  // panneau coulissant est le <dialog> à l'intérieur. C'est LÀ qu'on injecte.
  function conteneurDuTiroir(drawer) {
    if (!drawer) return null;
    return drawer.querySelector("dialog") || drawer;
  }

  function renderAll(cart, realTotal, hasGift) {
    var drawer = findDrawer();
    if (!drawer) return;
    var conteneur = conteneurDuTiroir(drawer);
    if (FREE_SHIPPING_THRESHOLD > 0) renderShippingBar(conteneur, cart, realTotal);
    if (GIFT_VARIANT_IDS.length > 0) renderGiftWidget(conteneur, hasGift);
    lockGiftLines(conteneur);
    nettoyerTiroir(conteneur);
  }

  // Masque le bloc « Réduction » et compacte l'espace du tiroir
  function nettoyerTiroir(conteneur) {
    if (!conteneur) return;

    // 1. Par classe (rapide) : tout ce qui ressemble à un bloc discount/réduction
    Array.prototype.forEach.call(
      conteneur.querySelectorAll("[class*='discount' i], [class*='reduction' i]"),
      function (el) {
        if (!el.closest("#a7-gift-widget")) el.style.display = "none";
      }
    );

    // 2. Par texte (filet de sécurité) : l'accordéon dont le libellé est « Réduction »
    Array.prototype.forEach.call(
      conteneur.querySelectorAll("summary, button, h2, h3, span, div"),
      function (el) {
        if (el.children.length > 1) return;
        var txt = (el.textContent || "").trim();
        if (txt === "Réduction" || txt === "Réductions" || txt === "Discount") {
          var bloc = el.closest("details, li, section") || el.parentElement;
          if (bloc && !bloc.closest("#a7-gift-widget")) bloc.style.display = "none";
        }
      }
    );
  }

  // 1. Barre de livraison gratuite (style Rhode)
  function renderShippingBar(drawer, cart, realTotal) {
    var bar = document.getElementById("a7-shipping-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.id = "a7-shipping-bar";
      var top = findItemsTop(drawer);
      if (top && top.parentElement) top.parentElement.insertBefore(bar, top);
      else drawer.prepend(bar);
    }

    var itemCount = 0;
    cart.items.forEach(function (i) {
      if (GIFT_VARIANT_IDS.indexOf(i.variant_id) === -1) itemCount += i.quantity;
    });

    var remaining = FREE_SHIPPING_THRESHOLD - realTotal;
    var pct = Math.min((realTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
    var msg, fill;
    if (remaining <= 0) {
      msg = '<span class="a7-bar-done">Livraison gratuite débloquée</span>';
      fill = "#5E7A5C";
    } else {
      msg = "Ajoute <strong>" + formatMoney(remaining) + "</strong> pour la livraison gratuite";
      fill = "#1A1A1A";
    }

    bar.innerHTML =
      '<div class="a7-bar-top">' +
        '<span class="a7-bar-count">' + itemCount + " article" + (itemCount > 1 ? "s" : "") + '</span>' +
        '<span class="a7-bar-msg">' + msg + '</span>' +
      '</div>' +
      '<div class="a7-bar-track"><div class="a7-bar-fill" style="width:' + pct + '%;background:' + fill + '"></div></div>';
  }

  // 2. Widget cadeau / upsell — au-dessus du footer, ou après le bloc
  // « panier vide », ou à la fin du tiroir en dernier recours.
  function visible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function renderGiftWidget(conteneur, giftAdded) {
    var footer = findFooter(conteneur);
    if (footer && !visible(footer)) footer = null; // ancre cachée = inutilisable

    var widget = document.getElementById("a7-gift-widget");
    if (!widget) {
      widget = document.createElement("div");
      widget.id = "a7-gift-widget";
    }

    // Choix du point d'insertion, du meilleur au pire :
    if (footer && footer.parentElement) {
      if (widget.nextElementSibling !== footer) footer.parentElement.insertBefore(widget, footer);
    } else {
      // Panier vide : insère après le bloc d'état vide s'il existe
      var vide = conteneur.querySelector("[class*='empty' i]");
      if (vide && visible(vide) && vide.parentElement) {
        if (vide.nextElementSibling !== widget) vide.parentElement.insertBefore(widget, vide.nextElementSibling);
      } else if (widget.parentElement !== conteneur) {
        conteneur.appendChild(widget);
      }
    }

    if (giftAdded) renderUpsell(widget);
    else renderGiftSelector(widget);

    if (!clickListenerAttached) {
      widget.addEventListener("click", handleClick);
      clickListenerAttached = true;
    }
  }

  function renderGiftSelector(container) {
    var gift = GIFTS[selectedGiftIndex];
    var imgUrl = giftImages[gift.handle] || "";
    var choicesHTML = GIFTS.length > 1
      ? '<div class="a7-gift-choices">' + GIFTS.map(function (g, i) {
          return '<button type="button" class="a7-gift-choice' + (i === selectedGiftIndex ? " a7-gift-choice--on" : "") + '" data-gift="' + i + '">' + g.displayLabel + "</button>";
        }).join("") + "</div>"
      : '<p class="a7-gift-name">' + gift.displayLabel + "</p>";
    var imgHTML = imgUrl
      ? '<img src="' + imgUrl + '" alt="" class="a7-gift-img">'
      : '<div class="a7-gift-img a7-gift-img--ph"></div>';

    container.style.display = "";
    container.innerHTML =
      '<div class="a7-widget">' +
        '<div class="a7-gift-label"><span class="a7-gift-tag">' + WIDGET_TAG + '</span> <em class="a7-gift-soustag">' + WIDGET_SOUS_TAG + '</em></div>' +
        '<div class="a7-gift-body">' +
          imgHTML +
          '<div class="a7-gift-info"><p class="a7-gift-price">GRATUIT</p>' + choicesHTML + '</div>' +
          (cartIsEmpty
            ? '<button id="a7-gift-btn" class="a7-gift-btn" type="button" disabled>Avec ta commande</button>'
            : '<button id="a7-gift-btn" class="a7-gift-btn" type="button">Ajouter</button>') +
        '</div>' +
        '<div class="a7-details-bar">' +
          '<button id="a7-details-toggle" class="a7-details-toggle" type="button">' +
            '<span id="a7-details-label">' + (detailsOpen ? "fermer les détails" : "plus de détails") + '</span>' +
          '</button>' +
        '</div>' +
        '<div id="a7-details-panel" class="a7-details-panel" style="display:' + (detailsOpen ? "block" : "none") + '">' +
          '<button id="a7-details-close" class="a7-details-close" type="button">&times;</button>' +
          '<p class="a7-details-title">Sent-bon gratuit avec ta commande</p>' +
          '<p class="a7-details-text">' + DETAILS_TEXT + '</p>' +
        '</div>' +
      '</div>';
  }

  function renderUpsell(container) {
    var available = UPSELLS.filter(function (u) {
      return u.variantId && currentCartVariantIds.indexOf(u.variantId) === -1;
    });
    if (!available.length) { container.innerHTML = ""; container.style.display = "none"; return; }
    container.style.display = "";
    currentUpsellIndex = ((currentUpsellIndex % available.length) + available.length) % available.length;
    var u = available[currentUpsellIndex];
    var img = upsellImages[u.handle] || "";
    var imgHTML = img
      ? '<img src="' + img + '" alt="" class="a7-upsell-img">'
      : '<div class="a7-upsell-img a7-upsell-img--ph"></div>';
    var priceHTML = (upsellPrices[u.handle] != null)
      ? '<span class="a7-upsell-price">' + formatMoney(upsellPrices[u.handle]) + '</span>' : "";

    container.innerHTML =
      '<div class="a7-widget">' +
        '<div class="a7-upsell-header">' +
          '<p class="a7-upsell-title">' + UPSELL_TITLE + '</p>' +
          '<span class="a7-upsell-progress">' + (currentUpsellIndex + 1) + " / " + available.length + '</span>' +
        '</div>' +
        '<div class="a7-upsell-card">' +
          imgHTML +
          '<span class="a7-upsell-meta"><span class="a7-upsell-name">' + u.displayLabel + '</span>' + priceHTML + '</span>' +
          '<button id="a7-upsell-btn" class="a7-upsell-btn" type="button" data-id="' + u.variantId + '">Ajouter</button>' +
        '</div>' +
        (available.length > 1
          ? '<div class="a7-upsell-nav">' +
              '<button class="a7-upsell-skip" id="a7-upsell-prev" type="button">&#8592; Précédent</button>' +
              '<button class="a7-upsell-skip" id="a7-upsell-next" type="button">Suivant &#8594;</button>' +
            '</div>'
          : "") +
      '</div>';
  }

  // Verrouille les lignes cadeau : aucun lien vers le produit, aucun
  // sélecteur de quantité. Repère les lignes par le TITRE du produit
  // (Horizon n'utilise pas toujours de lien dans le tiroir).
  function lockGiftLines(conteneur) {
    if (!conteneur) return;

    // Titres à repérer : ceux récupérés de l'API produit + les displayLabels
    var titres = [];
    GIFTS.forEach(function (g) {
      if (giftTitles[g.handle]) titres.push(giftTitles[g.handle].toLowerCase());
      if (g.displayLabel) titres.push(g.displayLabel.toLowerCase());
    });
    if (!titres.length) return;

    // 1. Trouve les nœuds de texte qui affichent un titre de cadeau
    var tousEls = conteneur.querySelectorAll("*");
    var lignes = [];
    Array.prototype.forEach.call(tousEls, function (el) {
      if (el.closest && el.closest("#a7-gift-widget")) return;
      if (el.children.length > 0) return; // on veut le nœud le plus profond
      var txt = (el.textContent || "").trim().toLowerCase();
      if (!txt || txt.length > 80) return;

      // Quel cadeau correspond à ce titre?
      var cadeau = null;
      GIFTS.forEach(function (g) {
        var t1 = (giftTitles[g.handle] || "").toLowerCase();
        var t2 = (g.displayLabel || "").toLowerCase();
        if (txt === t1 || txt === t2) cadeau = g;
      });
      if (!cadeau) return;

      // 2. Remonte jusqu'à l'ancêtre « ligne » : celui qui contient aussi
      //    un contrôle de quantité (le stepper − 1 +)
      var courant = el;
      for (var i = 0; i < 10 && courant && courant !== conteneur; i++) {
        courant = courant.parentElement;
        if (!courant) break;
        if (courant.querySelector("input[type='number'], input[inputmode='numeric'], quantity-selector, [class*='quantity' i]")) {
          lignes.push({ row: courant, gift: cadeau });
          break;
        }
      }
    });

    // 3. Verrouille chaque ligne trouvée
    lignes.forEach(function (item) {
      var row = item.row;
      var cadeau = item.gift;
      row.classList.add("a7-gift-line");

      // Désactive tous les liens (image + titre)
      Array.prototype.forEach.call(row.querySelectorAll("a"), function (lien) {
        lien.style.pointerEvents = "none";
        lien.style.textDecoration = "none";
        lien.setAttribute("tabindex", "-1");
        lien.setAttribute("aria-disabled", "true");
      });

      // Masque le stepper de quantité : on cache le conteneur du champ nombre
      Array.prototype.forEach.call(
        row.querySelectorAll("input[type='number'], input[inputmode='numeric']"),
        function (input) {
          var boite = input.closest("quantity-selector, [class*='quantity' i]") || input.parentElement;
          if (boite && boite !== row) boite.style.display = "none";
        }
      );
      // Filets de sécurité : composants et boutons +/− restants
      Array.prototype.forEach.call(
        row.querySelectorAll("quantity-selector, [class*='quantity' i], [name='plus'], [name='minus']"),
        function (q) { if (q !== row) q.style.display = "none"; }
      );
      Array.prototype.forEach.call(row.querySelectorAll("button"), function (b) {
        if (b.classList.contains("a7-gift-remove")) return;
        var t = (b.textContent || "").trim();
        var aria = (b.getAttribute("aria-label") || "").toLowerCase();
        if (t === "+" || t === "−" || t === "-" || /quantit|increase|decrease|augmenter|diminuer/.test(aria)) {
          var boite = b.parentElement;
          if (boite && boite !== row) boite.style.display = "none";
          else b.style.display = "none";
        }
      });

      // 4. Bouton « Retirer » maison — garanti visible, peu importe le thème
      if (!row.querySelector(".a7-gift-remove")) {
        var retirer = document.createElement("button");
        retirer.type = "button";
        retirer.className = "a7-gift-remove";
        retirer.textContent = "Retirer";
        retirer.addEventListener("click", async function (e) {
          e.preventDefault(); e.stopPropagation();
          retirer.textContent = "...";
          retirer.disabled = true;
          try {
            await removeFromCart([cadeau.variantId]);
            await refreshNativeCart();
            clickListenerAttached = false;
            isSyncing = false;
            await syncAndRender();
          } catch (err) {
            retirer.textContent = "Retirer";
            retirer.disabled = false;
          }
        });
        row.appendChild(retirer);
      }
    });
  }

  // ─── CLICS ────────────────────────────────────────────────────────────────

  async function handleClick(e) {
    var choiceBtn = e.target.closest(".a7-gift-choice");
    if (choiceBtn) {
      e.preventDefault(); e.stopPropagation();
      selectedGiftIndex = parseInt(choiceBtn.dataset.gift, 10);
      var w = document.getElementById("a7-gift-widget");
      if (w) renderGiftSelector(w);
      return;
    }

    var giftBtn = e.target.closest("#a7-gift-btn");
    if (giftBtn && !giftBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      giftBtn.textContent = "..."; giftBtn.disabled = true;
      try {
        await addToCart(GIFTS[selectedGiftIndex].variantId, { _gift: "true" });
        currentUpsellIndex = 0;
        await refreshNativeCart();
        clickListenerAttached = false;
        isSyncing = false;
        await syncAndRender();
      } catch (err) {
        giftBtn.textContent = "Erreur"; giftBtn.disabled = false;
      }
      return;
    }

    var upsellBtn = e.target.closest("#a7-upsell-btn");
    if (upsellBtn && !upsellBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(upsellBtn.dataset.id, 10);
      upsellBtn.textContent = "..."; upsellBtn.disabled = true;
      try {
        await addToCart(id);
        await refreshNativeCart();
        clickListenerAttached = false;
        debouncedSync();
      } catch (err) {
        upsellBtn.textContent = "Erreur"; upsellBtn.disabled = false;
      }
      return;
    }

    var toggleBtn = e.target.closest("#a7-details-toggle");
    if (toggleBtn) {
      e.preventDefault(); e.stopPropagation();
      detailsOpen = !detailsOpen;
      var panel = document.getElementById("a7-details-panel");
      var label = document.getElementById("a7-details-label");
      if (panel) panel.style.display = detailsOpen ? "block" : "none";
      if (label) label.textContent = detailsOpen ? "fermer les détails" : "plus de détails";
      return;
    }

    var closeBtn = e.target.closest("#a7-details-close");
    if (closeBtn) {
      e.preventDefault(); e.stopPropagation();
      detailsOpen = false;
      var panel = document.getElementById("a7-details-panel");
      var label = document.getElementById("a7-details-label");
      if (panel) panel.style.display = "none";
      if (label) label.textContent = "plus de détails";
      return;
    }

    var prevBtn = e.target.closest("#a7-upsell-prev");
    if (prevBtn) { e.preventDefault(); e.stopPropagation(); currentUpsellIndex--; clickListenerAttached = false; renderGiftWidget(conteneurDuTiroir(findDrawer()), true); return; }
    var nextBtn = e.target.closest("#a7-upsell-next");
    if (nextBtn) { e.preventDefault(); e.stopPropagation(); currentUpsellIndex++; clickListenerAttached = false; renderGiftWidget(conteneurDuTiroir(findDrawer()), true); return; }
  }

  // ─── STYLES ───────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById("a7-gift-styles")) return;
    var style = document.createElement("style");
    style.id = "a7-gift-styles";
    style.textContent = [
      /* Barre livraison gratuite */
      "#a7-shipping-bar{padding:16px 18px 12px;border-bottom:1px solid #E9E6DF;background:#FBFAF7;font-family:inherit}",
      ".a7-bar-top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:9px}",
      ".a7-bar-count{font-size:11px;font-weight:500;color:#8C8881;text-transform:uppercase;letter-spacing:.14em}",
      ".a7-bar-msg{font-size:12px;color:#5E5B54;text-align:right;line-height:1.4}",
      ".a7-bar-msg strong{color:#1A1A1A;font-weight:600}",
      ".a7-bar-done{color:#5E7A5C}",
      ".a7-bar-track{height:7px;background:#E6E2DA;border-radius:99px;overflow:hidden}",
      ".a7-bar-fill{height:100%;min-width:7px;border-radius:99px;transition:width .4s ease}",
      /* Widget — version compacte */
      "#a7-gift-widget{padding:4px 10px 3px;font-family:inherit;position:relative;z-index:1}",
      ".a7-widget{border:1px solid #E9E6DF;border-radius:10px;overflow:hidden;background:#F6F4EF}",
      ".a7-gift-label{padding:8px 10px 0;line-height:1.35}",
      ".a7-gift-tag{font-size:10px;font-weight:700;color:#6B675F;letter-spacing:.1em;text-transform:uppercase}",
      ".a7-gift-soustag{font-size:10.5px;color:#8C8881;font-style:italic;font-weight:400}",
      ".a7-gift-body{display:flex;align-items:center;gap:8px;padding:6px 10px 9px}",
      ".a7-gift-img{width:36px;height:36px;object-fit:cover;border-radius:6px;border:1px solid #E9E6DF;flex-shrink:0}",
      ".a7-gift-img--ph{background:#EDEAE3}",
      ".a7-gift-info{flex:1;min-width:0}",
      ".a7-gift-name{font-size:12px;font-weight:600;color:#1A1A1A;margin:0}",
      ".a7-gift-price{font-size:9.5px;font-weight:700;color:#5E7A5C;letter-spacing:.06em;margin:0 0 4px;text-transform:uppercase}",
      ".a7-gift-choices{display:flex;flex-wrap:wrap;gap:5px}",
      ".a7-gift-choice{font-size:11px;padding:5px 10px;border:1px solid #E3DFD7;border-radius:20px;background:#FBFAF7;color:#5E5B54;cursor:pointer;font-family:inherit;line-height:1.2}",
      ".a7-gift-choice--on{border-color:#1A1A1A;background:#1A1A1A;color:#FBFAF7}",
      ".a7-gift-btn{flex-shrink:0;padding:7px 12px;background:" + ACCENT + ";color:#fff;border:none;border-radius:20px;font-size:9.5px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;cursor:pointer;font-family:inherit;white-space:nowrap}",
      ".a7-gift-btn:hover{opacity:.85}",
      ".a7-gift-btn:disabled{opacity:.45;cursor:not-allowed}",
      /* Détails */
      ".a7-details-bar{border-top:1px solid #E9E6DF;padding:5px 10px}",
      ".a7-details-toggle{background:none;border:none;cursor:pointer;font-size:9.5px;color:#8C8881;font-family:inherit;padding:0;text-decoration:underline;text-underline-offset:2px}",
      ".a7-details-toggle:hover{color:#1A1A1A}",
      ".a7-details-panel{background:#2B2622;padding:12px 30px 12px 12px;position:relative}",
      ".a7-details-close{position:absolute;top:8px;right:10px;background:none;border:none;color:#fff;font-size:16px;cursor:pointer;opacity:.7;padding:0}",
      ".a7-details-title{font-size:10px;font-weight:700;color:#fff;text-transform:uppercase;letter-spacing:.08em;margin:0 0 5px}",
      ".a7-details-text{font-size:10.5px;color:rgba(255,255,255,.72);line-height:1.55;margin:0}",
      /* Upsell */
      ".a7-upsell-header{padding:11px 14px 2px;display:flex;align-items:center;justify-content:space-between}",
      ".a7-upsell-title{font-size:11px;font-weight:600;color:#8C8881;text-transform:uppercase;letter-spacing:.12em;margin:0}",
      ".a7-upsell-progress{font-size:11px;color:#A8A39B}",
      ".a7-upsell-card{display:flex;align-items:center;gap:12px;padding:8px 14px}",
      ".a7-upsell-img{width:44px;height:44px;object-fit:cover;border-radius:7px;flex-shrink:0;border:1px solid #E9E6DF}",
      ".a7-upsell-img--ph{background:#EDEAE3}",
      ".a7-upsell-meta{display:flex;flex-direction:column;gap:1px;flex:1;min-width:0}",
      ".a7-upsell-name{font-size:14px;color:#1A1A1A;font-weight:600;line-height:1.3}",
      ".a7-upsell-price{font-size:12px;color:#8C8881}",
      ".a7-upsell-btn{flex-shrink:0;padding:7px 13px;background:" + ACCENT + ";color:#fff;border:none;border-radius:20px;font-size:10.5px;font-weight:600;text-transform:uppercase;letter-spacing:.1em;cursor:pointer;font-family:inherit}",
      ".a7-upsell-btn:hover{opacity:.85}",
      ".a7-upsell-btn:disabled{opacity:.45;cursor:not-allowed}",
      ".a7-upsell-nav{display:flex;justify-content:space-between;padding:2px 14px 10px}",
      ".a7-upsell-skip{background:none;border:none;font-size:10.5px;color:#8C8881;cursor:pointer;font-family:inherit;padding:0}",
      ".a7-upsell-skip:hover{color:#1A1A1A}",
      /* Lignes cadeau : aucun lien cliquable, aucun sélecteur de quantité */
      ".a7-gift-line a{pointer-events:none!important;text-decoration:none!important;cursor:default!important}",
      ".a7-gift-line quantity-selector,.a7-gift-line [class*='quantity' i],.a7-gift-line input[type='number']{display:none!important}",
      ".a7-gift-line button[name='plus'],.a7-gift-line button[name='minus']{display:none!important}",
      /* Bouton Retirer maison sur la ligne cadeau */
      ".a7-gift-line .a7-gift-remove{display:inline-block!important;background:none;border:none;cursor:pointer;font-size:11px;color:#8C8881;font-family:inherit;padding:2px 0 0;text-decoration:underline;text-underline-offset:2px;pointer-events:auto!important}",
      ".a7-gift-line .a7-gift-remove:hover{color:#1A1A1A}",
      ".a7-gift-line .a7-gift-remove:disabled{opacity:.5;cursor:default}",
      /* Optimisation de l'espace du tiroir */
      "cart-drawer dialog [class*='discount' i],cart-drawer-component dialog [class*='discount' i]{display:none!important}",
      "cart-drawer dialog [class*='summary' i]{padding-top:10px!important}",
      "cart-drawer dialog hr,cart-drawer-component dialog hr{margin:8px 0!important}",
    ].join("");
    document.head.appendChild(style);
  }

  // ─── OBSERVER & INIT ──────────────────────────────────────────────────────

  function observeCart() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.id === "a7-shipping-bar" || t.id === "a7-gift-widget") continue;
        if (t.closest && t.closest("#a7-shipping-bar,#a7-gift-widget")) continue;
        var drawer = findDrawer();
        if (drawer && (t === drawer || (t.closest && t.closest("cart-drawer-component, cart-drawer, .cart-drawer")))) {
          clickListenerAttached = false;
          debouncedSync();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (!GIFT_VARIANT_IDS.length) {
      console.warn("[5a7] Aucun cadeau configuré — remplis GIFTS en haut du fichier (variantId + handle).");
    }
    injectStyles();
    observeCart();

    // Vérification périodique : Horizon peut créer/re-rendre le tiroir à
    // n'importe quel moment. Si le tiroir existe mais que le widget a
    // disparu (ou n'a jamais été injecté), on resynchronise.
    var drawerAbsentLog = false;
    setInterval(function () {
      var drawer = findDrawer();
      if (!drawer) {
        if (!drawerAbsentLog) { drawerAbsentLog = true; console.log("[5a7] tiroir de panier introuvable pour l'instant — envoie-moi le HTML du panier si ça persiste"); }
        return;
      }
      if (!document.getElementById("a7-gift-widget")) {
        clickListenerAttached = false;
        debouncedSync(50);
      }
    }, 1000);

    // Évènements de panier (Horizon + génériques)
    ["cart:update", "cart:refresh", "CartUpdateEvent", "dialog:open", "cartdrawer:opened"].forEach(function (evt) {
      document.addEventListener(evt, function () {
        clickListenerAttached = false;
        debouncedSync(200);
      });
    });

    // Clic sur l'icône panier / boutons ajouter au panier
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest('[aria-controls*="cart"], a[href="/cart"], [class*="cart-icon"], .header-actions__cart-icon, [id*="cart-icon"]');
      if (trigger) {
        setTimeout(function () { debouncedSync(100); }, 350);
        setTimeout(function () { debouncedSync(100); }, 700);
      }
      var addBtn = e.target.closest('[name="add"], [data-add-to-cart], .product-form__submit, button[type="submit"][form*="product"]');
      if (addBtn) debouncedSync(600);
    }, true);

    syncAndRender();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

})();
